import React from 'react'
import { ForwardRefExoticComponent, SVGProps } from 'react'

import { Check } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import CheckboxElementQuestion from 'modules/forms/components/QuestionComponent/CheckboxElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, Options } from 'modules/forms/lib/types'

export class CheckboxElement extends Element {
  static create({ label, options = {} }: { label: string; options: Options }): CheckboxElement {
    const el = new CheckboxElement({
      label,
      description: options.description,
      mandatory: options.mandatory || options.locked,
    })
    if (options.locked) {
      el.lock()
    }

    return el
  }

  getName(): string {
    return i18n.t('forms.modals.elements.checkbox')
  }

  getType(): FormsElementTypeEnum {
    return 'checkbox'
  }

  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return Check
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <CheckboxElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <CheckboxElementQuestion element={this} onChange={onChange} />
  }
}
